












































import Vue from 'vue'
import _ from 'lodash'
import { Competence } from '@/model/qcq/Competence'
import { LOAD_COMPETENCE } from '@/store/action-types'
import { QcqCommonGridItem } from '@/types'
import { EmployeeQcqCompetence } from '@/model/employee/EmployeeQcqCompetence'

interface ComponentData {
  competencesList: Array<QcqCommonGridItem>
  selectedCompetence: number | null
  competenceValidationRules: Array<Function>
  formData: EmployeeQcqCompetence | undefined
  numberOfStars: number | null
  isStar1Disabled: boolean
  isStar2Disabled: boolean
  isStar3Disabled: boolean
  isStar4Disabled: boolean
  isStar5Disabled: boolean
}

interface Payload {
  selectedCompetence: number | null
  quality: number | null
}

export default Vue.extend({
  name: 'QcqCompetenceDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object as () => EmployeeQcqCompetence
    },
    employeeComepetences: Array as () => any,
    loading: Boolean,
    isCompetencesQualityEnabled: Boolean,
    stars: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      competencesList: [],
      selectedCompetence: null,
      competenceValidationRules: [
        required
      ],
      formData: undefined,
      numberOfStars: null,
      isStar1Disabled: true,
      isStar2Disabled: true,
      isStar3Disabled: true,
      isStar4Disabled: true,
      isStar5Disabled: true,
    }
  },

  watch: {
    show (newVal: boolean): void {
      if (newVal) {
        const form: any = this.$refs['form']
        if(form) {
          form.resetValidation()
        }

        setTimeout(() => {
          const searchField: any = this.$refs['searchField']
          if (searchField) {
            searchField.focus()
          }
        })

        this.selectedCompetence = null
        this.formData = _.cloneDeep(this.dialogData)
        this.selectedCompetence = this.formData.competenceId
        this.numberOfStars = this.formData.quality
        this.fetchQuality()
      }
    }
  },

  computed: {
    filteredCompetencesList (): any {
      let list: Array<QcqCommonGridItem> = []
      this.competencesList.forEach((item: QcqCommonGridItem) => {
        if (!this.employeeComepetences.includes(item.id)) {
          list.push(item)
        }
      })
      return _.sortBy(list,  [i => i.description.toLowerCase()])
    }
  },

  methods: {

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        const payload: Payload = {
          selectedCompetence: this.selectedCompetence,
          quality: this.numberOfStars
        }
        this.$emit('save', payload)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onResetButtonClick (): void {
      this.resetStars()
    },
    resetStars (): void {
      this.isStar1Disabled = true
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = null
    },
    star1 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 1
    },
    star2 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 2
    },
    star3 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 3
    },
    star4 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = true
      this.numberOfStars = 4
    },
    star5 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = false
      this.numberOfStars = 5
    },

    fetchQuality (): void {
      switch (this.numberOfStars) {
        case null:
          this.resetStars()
          break
        case 1:
          this.star1()
          break
        case 2:
          this.star2()
          break
        case 3:
          this.star3()
          break
        case 4:
          this.star4()
          break
        case 5:
          this.star5()
          break
      }
    }
  },

  async mounted (): Promise<void> {

    this.$store.dispatch(LOAD_COMPETENCE, 1)
      .then((data: Array<Competence>) => {
        data.forEach((item: Competence) => {
          this.competencesList.push(item.commonGridData)
        })
      })

    setTimeout(() => {
      const searchField: any = this.$refs['searchField']
      if (searchField) {
        searchField.focus()
      }
    })
  }
})
